import React, { Fragment } from "react";
import MenuItem from "./MenuItem";
import ProfileBox from "./ProfileBox";
import { useMenuContext } from "../contexts/MenuContext";
import { useSchoolTeacherContext } from "../contexts/SchoolTeacherContext";

const Menu = () => {
        const menuContent = useMenuContext();
        const { teacherData: teacher } = useSchoolTeacherContext();

        return (
                <div className="left-panel">
                        <div className="menu">
                                {/* Profile section here */}

                                <ProfileBox teacher={teacher} />

                                {menuContent.map((section) => (
                                        <Fragment key={section.title}>
                                                <div className="menu-section-title">{section.title}</div>
                                                {section.items.map((item) => (
                                                        <MenuItem key={item.route} item={item} section={section} />
                                                ))}
                                        </Fragment>
                                ))}
                        </div>
                </div>
        );
}

export default Menu;